import * as angular from 'angular';

class PeriodInputComponentCtrl implements ng.IController {
    private period: Period | FlexibleLeadTimePeriodDto;
    private periodPattern: RegExp = /^[0-9]+$/;
    private isSavedInstantly: boolean;
    private setNegativeToZero: boolean;
    private forbidZeroValue: boolean;
    private timeUnits: PeriodType[] | FlexibleLeadTimeUnit[];
    private defaultTimeUnit: PeriodType | FlexibleLeadTimeUnit;
    private isFlexibleLeadTime: boolean;
    private customTimeUnits: any;
    private onSavePeriod: any;
    private onSaveUnit: any;

    public ngModelCtrl: angular.INgModelController;

    constructor(private $scope: ng.IScope) {
        if (this.isFlexibleLeadTime) {
            this.timeUnits = ['HOUR', 'DAY', 'WORKING_DAY', 'MONTH', 'YEAR'];
        } else if (this.customTimeUnits) {
            this.timeUnits = this.customTimeUnits;
        } else {
            this.timeUnits = [
                'HOUR',
                'YEAR',
                'REST_OF_YEAR',
                'QUARTER',
                'MONTH',
                'DAY',
                'WITHINDAY',
                'MULTIHOUR'
            ];
        }

        // Just initialized once and will not change dynamically.
        if (this.forbidZeroValue) {
            this.periodPattern = /^[1-9][0-9]*$/;
        }

        this.defaultTimeUnit = this.timeUnits[0];
    }

    $onInit() {
        this.$scope.$watch(
            () => {
                if (!this.period) {
                    this.period = <Period | FlexibleLeadTimePeriodDto>{};
                }
                if (!this.period.type) {
                    this.period.type = this.defaultTimeUnit;
                }

                return this.period;
            },
            () => this.ngModelCtrl.$setViewValue(angular.copy(this.period)),
            true
        );

        this.ngModelCtrl.$parsers.push(
            (viewValue: Period | FlexibleLeadTimePeriodDto) => {
                if (!viewValue.type) {
                    viewValue.type = this.defaultTimeUnit;
                }

                return viewValue;
            }
        );

        this.ngModelCtrl.$render = () => {
            this.period = this.ngModelCtrl.$modelValue;
        };
    }

    private changePeriodTimeUnit(
        periodType: PeriodType | FlexibleLeadTimeUnit
    ) {
        this.period.type = periodType;
        this.ngModelCtrl.$setViewValue(angular.copy(this.period));
    }

    public savePeriod() {
        if (this.isSavedInstantly) {
            if (
                this.setNegativeToZero &&
                (this.period.value == null || this.period.value <= 0)
            ) {
                this.period.value = 0;
                this.ngModelCtrl.$setViewValue(angular.copy(this.period));
            }

            if (
                !this.forbidZeroValue ||
                (this.period.value != null && this.period.value > 0)
            ) {
                return this.onSavePeriod();
            }
        }
    }

    public saveUnit() {
        if (this.isSavedInstantly) {
            if (
                this.setNegativeToZero &&
                (this.period.value == null || this.period.value <= 0)
            ) {
                this.period.value = 0;
                this.ngModelCtrl.$setViewValue(angular.copy(this.period));
            }
            if (
                !this.forbidZeroValue ||
                (this.period.value != null && this.period.value > 0)
            ) {
                return this.onSaveUnit();
            }
        }
    }
}

angular.module('app').component('pkpPeriodInput', {
    controller: PeriodInputComponentCtrl,
    template: require('app/_directives/period-input.component.html'),
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        isFlexibleLeadTime: '=',
        customTimeUnits: '=',
        supportedPeriods: '=',
        isSavedInstantly: '=',
        onSavePeriod: '&',
        onSaveUnit: '&',
        setNegativeToZero: '=',
        forbidZeroValue: '='
    }
});
